import { isNil, isEmpty } from 'ramda';

export const oxford = (elements, conjunction) => {
  if (isNil(elements) || isEmpty(elements)) {
    return '';
  }

  const count = elements.length;
  if (count < 2) {
    return elements[0];
  }

  if (count < 3) {
    return elements.join(` ${conjunction} `);
  }

  const main = elements.slice(0, count - 1).join(`, `);
  const suffix = ` ${conjunction} ${elements[count - 1]}`;

  return `${main} ${suffix}`;
};
